<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.aerators.createProgrammed")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <AveineAeratorProgrammedForm :APIbaseURL="APIbaseURL" :programmed="programmed" :updateHistory="updateHistory" :dfuPackages="dfuPackages" :adminMode="true"/>
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineAeratorProgrammedForm } from 'aveine-aerator'
import { ProgrammedUpdate, DfuPackage, UpdateHistory, User, Aerator } from 'aveine-toolbox'
export default {
  data () {
    return {
      programmed: {},
      updateHistory: {},
      dfuPackages: [],
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Create',
  components: {
    AveineAeratorProgrammedForm
  },
  async created() {
    await User.api().get(`users/${this.$route.params.userId}`, {params: {include: "profile"}})
    const user = await User.query().whereId(this.$route.params.userId).withAllRecursive().first();
    await Aerator.api().get(`aerators/${this.$route.params.aeratorId}`)
    const aerator = await Aerator.query().whereId(this.$route.params.aeratorId).withAllRecursive().first();
    let reqProgrammed = await ProgrammedUpdate.insert({
      data: {
        $isNew: true,
        user,
        aerator
      }
    })

    this.programmed = await ProgrammedUpdate.query().whereId(reqProgrammed.programmed_updates[0].id).withAllRecursive().first();

    let reqHistory = await UpdateHistory.insert({
      data: {
        $isNew: true,
        aerator
      }
    })
    
    this.updateHistory = await UpdateHistory.query().whereId(reqHistory.update_histories[0].id).withAllRecursive().first();
    
    const that = this;

    let dfuPackages = await DfuPackage.api().get(`dfu-packages?lang=${this.$i18n.locale}`, {
        params: {
          include: 'target-hardware',
          "sort": "created-at",
          "page[size]": 1000
        }
      }
    );

    dfuPackages.response.data.map(async (dfuPackage) => {
      if (!dfuPackage.deleted) {
        const dfuPackageToPush = await DfuPackage.query().whereId(dfuPackage.id).withAllRecursive().first()
        that.dfuPackages.push({value: dfuPackageToPush, label: dfuPackageToPush.name})
      }
    });

    this.dataLoaded = true;
  },
}
</script>
